import React, {useEffect, useState} from "react";
import {getTaskTypes} from 'api';
import {Button, Form, Input, Table, Row, Col, Modal} from "antd";
import {confirmAlert} from "react-confirm-alert";
import {Link} from "react-router-dom";
import {isAdministrator} from "../../../utils/UserInfo";
import AddEditTypeDialog from "./AddEditTypeDialog";


function TypesView(props){

    const [taskTypes,setTaskTypes] = useState([]);

    useEffect(() => {
        async function getTypes() {
            let types = await getTaskTypes();
            setTaskTypes(types.data);
        }
        getTypes();
    }, []);

    function EditCellFormatter(cell, row)
    {
        if(isAdministrator())
            return (<Link to={`#`} onClick={() => openEditDialog(row)}><strong>{row.taskType}</strong></Link>);
        else
            return (<>{row.taskType}</>);
    }
    function CreatedByFormatter(cell, row)
    {
        return (
            <div>{row.createdBy}{' '}{row.createdDate}</div>
        );
    }
    function openEditDialog(row)
    {
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <AddEditTypeDialog action={'Edit'} type={row} onClose={onClose} setTaskTypes={setTaskTypes}/>
                );
            }
        });
    }
    function OpenAddNewTypeDialog()
    {
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <AddEditTypeDialog action={'Add'} type={null} onClose={onClose} setTaskTypes={setTaskTypes}/>
                );
            }
        });
    }

    const TypeColumns = [
        {
            title: 'Task Type ID',
            dataIndex: 'typeId',
            key: 'typeId',
        },
        {
            title: 'Task Type',
            dataIndex: 'taskType',
            key: 'taskType',
            //render: EditCellFormatter
        },
        {
            title: 'Project Task',
            dataIndex: 'projectTask',
            key: 'projectTask'
        },
        {
            title: 'PreJob Order',
            dataIndex: 'preJobOrder',
            key: 'preJobOrder'
        },
        {
            title: 'PostJob Order',
            dataIndex: 'postJobOrder',
            key: 'postJobOrder'
        },
        {
            title: 'Removals Order',
            dataIndex: 'removalsOrder',
            key: 'removalsOrder'
        },
        {
            title: 'CIP Order',
            dataIndex: 'cipOrder',
            key: 'cipOrder'
        },
        {
            title: 'Asset Task',
            dataIndex: 'assetTask',
            key: 'assetTask'
        },
        {
            title: 'Asset Task Order',
            dataIndex: 'assetTaskOrder',
            key: 'assetTaskOrder'
        },
        {
            title: 'Form Tasks',
            dataIndex: 'formTask',
            key: 'formTask'
        },
        {
            title: 'Form Task Order',
            dataIndex: 'formTaskOrder',
            key: 'formTaskOrder'
        },
        {
            title: 'Created By',
            dataIndex: 'createdBy',
            key: 'createdBy',
            render: CreatedByFormatter
        }
    ];

    return (
        <div>
            {/*<Row>
                <Col>
                    {isAdministrator() &&
                    <Button
                        type='primary'
                        style={{alignItems: 'end', alignContent: 'end'}}
                        onClick={() => OpenAddNewTypeDialog()}
                    >
                        Add New Type
                    </Button>
                    }
                </Col>
            </Row>*/}
            <Table
                bordered
                dataSource={taskTypes}
                columns={TypeColumns}
                pagination={false}
                //scroll={{ y: 250 }}
                style={{ paddingTop: '15px', paddingBottom: '15px' }}
            />
        </div>
    )
}
export default TypesView;